import { Howl } from 'howler';
import { ASSETS } from '../assetManifest';
import { CONSTANTS } from '../data';

export class AudioManager {
  private sounds: { [key: string]: Howl } = {};
  private musicVolume: number = CONSTANTS.AUDIO.DEFAULT_MUSIC_VOLUME;
  private sfxVolume: number = CONSTANTS.AUDIO.DEFAULT_SFX_VOLUME;
  private isMuted: boolean = false;
  private backgroundMusic: Howl | null = null;

  constructor() {
    this.initializeSounds();
  }

  private initializeSounds() {
    // Initialize background music
    if (ASSETS.music?.backgroundMusic?.path) {
      this.backgroundMusic = new Howl({
        src: [ASSETS.music.backgroundMusic.path],
        loop: true,
        volume: this.musicVolume,
      });
    }

    // Initialize sound effects
    Object.entries(CONSTANTS.AUDIO.SOUND_EFFECTS).forEach(([key, soundKey]) => {
      const assetPath = (ASSETS.sfx as any)?.[soundKey]?.path;
      if (assetPath) {
        this.sounds[key] = new Howl({
          src: [assetPath],
          volume: this.sfxVolume,
        });
      }
    });
  }

  playSound(soundKey: string) {
    if (this.isMuted) return;
    const sound = this.sounds[soundKey];
    if (sound) {
      sound.play();
    }
  }

  startBackgroundMusic() {
    if (this.isMuted || !this.backgroundMusic) return;
    if (!this.backgroundMusic.playing()) {
      this.backgroundMusic.play();
    }
  }

  stopBackgroundMusic() {
    if (this.backgroundMusic) {
      this.backgroundMusic.stop();
    }
  }

  setMusicVolume(volume: number) {
    this.musicVolume = volume;
    if (this.backgroundMusic) {
      this.backgroundMusic.volume(this.isMuted ? 0 : volume);
    }
  }

  setSfxVolume(volume: number) {
    this.sfxVolume = volume;
    Object.values(this.sounds).forEach(sound => {
      sound.volume(this.isMuted ? 0 : volume);
    });
  }

  setMuted(muted: boolean) {
    this.isMuted = muted;
    if (this.backgroundMusic) {
      this.backgroundMusic.volume(muted ? 0 : this.musicVolume);
    }
    Object.values(this.sounds).forEach(sound => {
      sound.volume(muted ? 0 : this.sfxVolume);
    });
  }

  getMusicVolume() { return this.musicVolume; }
  getSfxVolume() { return this.sfxVolume; }
  getIsMuted() { return this.isMuted; }
}
